import React from "react";
import { Icon } from "semantic-ui-react";
import './index.scss';

const BannedIcon = ({ primary, size, style, iconName, iconClassName = '', banIconSize = 'small' }) => {
    return (
        <Icon.Group {...(size ? { size } : { className: `BannedIcon ${iconClassName}` })} style={style}>
            <Icon disabled link className={iconName} {...(primary ? { color: 'primary' } : {})} />
            <Icon size={banIconSize} corner className='fas fa-ban' color='red' />
        </Icon.Group>
    )
}

export default BannedIcon;
